import Styled from 'styled-components'

export const Container = Styled.div`
`

export const Banner = Styled.div`
`

export const ContainerTicketData = Styled.section`
`

export const ContainerContent = Styled.div`
`
export const SearchTicket = Styled.h3`
`

export const CheckboxContainer = Styled.div`
`

export const Radio = Styled.input`

`
export const ContainerInput = Styled.div`
`

export const ContainerInputRigth = Styled.div`
`






export const ContainerInputLeft = Styled.div`

`
export const Select = Styled.select`
`
export const Option = Styled.option`
`
export const Input = Styled.input`
`

export const Spance = Styled.div`
`

export const Ticket = Styled.h4`
`


export const ContainerCarousel = Styled.div`
`

export const Img = Styled.img`
`
export const ContainerCarouselCard = Styled.div`
`

export const ContentCarousel = Styled.div`
`

export const ListContainer = Styled.div`
`

export const List = Styled.ul`
`

export const ListItem = Styled.li`
`